var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('el-header',{staticStyle:{"padding":"0"},attrs:{"id":"headerBox"}},[_c('header-dom')],1),_c('el-main',{staticStyle:{"width":"100%","padding":"0","overflow":"hidden"}},[_c('router-view')],1),_c('el-footer',{staticStyle:{"padding":"0"},attrs:{"id":"footerBox"}},[_c('footer-dom')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }